import { endOfMonth, isAfter } from 'date-fns';
import padStart from 'lodash/padStart';
import { toDate } from 'lib/utils';
import { SelfServiceAPI } from 'types';

export type CreditCardExpiry = Pick<SelfServiceAPI.CreditCardPaymentMethod, 'expiryMonth' | 'expiryYear'>;

export const isCreditCardExpired = (now: number | Date, { expiryMonth, expiryYear }: CreditCardExpiry) => {
  if (!expiryMonth || !expiryYear) {
    return false;
  }

  const year = padStart(expiryYear, 4, '20');
  const month = padStart(expiryMonth, 2, '0');
  const expiryDate = endOfMonth(toDate(`${year}-${month}-01`));

  return isAfter(now, expiryDate);
};
